import { render } from "./layout.vue?vue&type=template&id=3a6329e1&scoped=true"
import script from "./layout.vue?vue&type=script&lang=js"
export * from "./layout.vue?vue&type=script&lang=js"

import "./layout.vue?vue&type=style&index=0&id=3a6329e1&rel=stylesheet%2Fscss&lang=scss&scoped=true"

import exportComponent from "/home/pages/train-manage/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a6329e1"]])

export default __exports__